import axios from "axios";
import { useAuth } from "../../contexts/AuthContext";
import { useTenant } from "../../contexts/TenantService";

function CredentialMgmtDataService() {
  const { authService } = useAuth();
  const { tenantSvc } = useTenant();
  const apiUrl = tenantSvc?.apiUrl;
  // const apiUrl = "http://localhost:8000/usermgmt/v1";
  const tenantIdentifier = tenantSvc?.tenantId;
  const token = authService?.getAccessToken();

  const validateToken = (resource, params) => {
    return axios.post(`${apiUrl}/${tenantIdentifier}` + resource, params, {
      withCredentials: true,
    });
  };

  const activateUser = (resource, params) => {
    return axios.post(`${apiUrl}/${tenantIdentifier}` + resource, params, {
      withCredentials: true,
    });
  };

  const forgotPassword = (resource, params) => {
    return axios.post(`${apiUrl}/${tenantIdentifier}` + resource, params, {
      withCredentials: true,
    });
  };

  const changePassword = (resource, params) => {
    return axios.post(`${apiUrl}/${tenantIdentifier}` + resource, params, {
      headers: { Authorization: `bearer ${token}` },
    });
  };
  return {
    validateToken,
    activateUser,
    forgotPassword,
    changePassword,
  };
}

export default CredentialMgmtDataService;
